module.exports = __webpack_public_path__ + "static/media/onboarding_2.ccc8b43a.png";


/*****************
 ** WEBPACK FOOTER
 ** ./public/images/doodles/onboarding_2.png
 ** module id = 1985
 ** module chunks = 50
 **/